import * as React from 'react';
import { cn } from '../../lib/utils';

export const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      // Spike scale: 12.5px semibold, not 14px medium. Labels sit above every
      // field on every form, so the wrong weight here is the wrong weight on
      // every screen with a field on it.
      className={cn(
        'text-[12.5px] font-semibold text-foreground peer-disabled:text-muted-foreground',
        className,
      )}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
